export const TIMEZONE_OPTIONS = [
  { value: "Europe/Kaliningrad", label: "Калининград - UTC+2", shortLabel: "Калининград, UTC+2" },
  { value: "Europe/Moscow", label: "Москва - UTC+3", shortLabel: "Москва, UTC+3" },
  { value: "Europe/Samara", label: "Самара - UTC+4", shortLabel: "Самара, UTC+4" },
  { value: "Asia/Yekaterinburg", label: "Екатеринбург - UTC+5", shortLabel: "Екатеринбург, UTC+5" },
  { value: "Asia/Omsk", label: "Омск - UTC+6", shortLabel: "Омск, UTC+6" },
  { value: "Asia/Novosibirsk", label: "Новосибирск - UTC+7", shortLabel: "Новосибирск, UTC+7" },
  { value: "Asia/Krasnoyarsk", label: "Красноярск - UTC+7", shortLabel: "Красноярск, UTC+7" },
  { value: "Asia/Irkutsk", label: "Иркутск - UTC+8", shortLabel: "Иркутск, UTC+8" },
  { value: "Asia/Yakutsk", label: "Якутск - UTC+9", shortLabel: "Якутск, UTC+9" },
  { value: "Asia/Vladivostok", label: "Владивосток - UTC+10", shortLabel: "Владивосток, UTC+10" },
  { value: "Asia/Magadan", label: "Магадан - UTC+11", shortLabel: "Магадан, UTC+11" },
  { value: "Asia/Kamchatka", label: "Камчатка - UTC+12", shortLabel: "Камчатка, UTC+12" },
  { value: "UTC", label: "UTC", shortLabel: "UTC" },
];

export const getTimezoneOption = (value) =>
  TIMEZONE_OPTIONS.find((option) => option.value === value) || TIMEZONE_OPTIONS[1];
